import { createAction } from "@reduxjs/toolkit";

export const getEmployeeRoles = createAction("@__get_roles");
export const getCities = createAction("@__get_cities");
export const getAreas = createAction("@__get_areas");
export const getSettings = createAction("@__get_settings");
export const getEnumsAction = createAction("@__get_enums");
